
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 12","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.864.804a.75.75 0 00-1.061 1.06l1.06-1.06zM13 6l.53.53a.75.75 0 000-1.06L13 6zm-5.197 4.136a.75.75 0 101.06 1.06l-1.06-1.06zM1 5.251a.75.75 0 000 1.5v-1.5zm6.803-3.387l4.667 4.667 1.06-1.06L8.864.803l-1.061 1.06zM12.47 5.47l-4.667 4.667 1.06 1.06 4.667-4.666-1.06-1.06zm.53-.22H1v1.5h12v-1.5z"}})])
          )
        }
      }
    